import { handleActions } from 'redux-actions';
import * as constants from './constants';

export const initialState = {
  webchatWidgets: [],
  webchatOrgStatus: {
    orgStatus: '',
    orgStatusReason: '',
    orgStatusUpdatedAt: '',
  },
  webchatWidgetSettingsTypes: {},
};

function setWebchatWidgets(state, { payload }) {
  const { webchatWidgets } = payload;
  return { ...state, webchatWidgets };
}

function setWebchatOrgStatus(state, { payload }) {
  const { getOrgStatus } = payload;
  return { ...state, webchatOrgStatus: getOrgStatus };
}

function setWebchatUpdatedOrgStatus(state, { payload }) {
  const { updateOrgStatus } = payload;
  return { ...state, webchatOrgStatus: updateOrgStatus };
}

function setWebChatWidgetSettingsTypes(state, { payload }) {
  return {
    ...state,
    webchatWidgetSettingsTypes: payload.getWidgetSettingsTypes,
  };
}

export default handleActions(
  {
    [constants.FETCH_WEBCHAT_WIDGETS_SUCCESS]: setWebchatWidgets,
    [constants.FETCH_WEBCHAT_ORG_STATUS_SUCCESS]: setWebchatOrgStatus,
    [constants.WEBCHAT_REMOVE_ORG_SUCCESS]: setWebchatUpdatedOrgStatus,
    [constants.WEBCHAT_SUSPEND_ORG_SUCCESS]: setWebchatUpdatedOrgStatus,
    [constants.WEBCHAT_REACTIVATE_ORG_SUCCESS]: setWebchatUpdatedOrgStatus,
    [constants.WEBCHAT_WIDGET_SETTINGS_TYPES_SUCCESS]:
      setWebChatWidgetSettingsTypes,
  },
  initialState
);
